import { connect } from 'react-redux';

import {
  reserveBoardgame,
  getBackBoardgame,
} from '../actions/boardgames';

import {
  visibleBoardgamesByIdSelector,
  loadingSelector,
} from '../reducers/boardgames';

import ScanQrModalComponent from '../components/ScanQrModal';

const mapStateToProps = state => {
  return {
    boardgamesById: visibleBoardgamesByIdSelector(state),
    loading: loadingSelector(state),
  };
};

const mapDispatchToProps = dispatch => {
  return { 
    reserveBoardgame: (id) => dispatch(reserveBoardgame(id)),
    getBackBoardgame: (id) => dispatch(getBackBoardgame(id)),
  };
};

const ScanQrModal = connect(mapStateToProps, mapDispatchToProps)(ScanQrModalComponent);

export default ScanQrModal;

